import APP from './app';

const FOOTER = {
  INFO: `${APP.LEGAL_NAME} - CNPJ 23.895.251/0001-87`,
  COPYRIGHT: `© Promobit 2014-${new Date().getUTCFullYear()}`,
};

export default FOOTER;
